import React from "react"
import { Building, findBuildingByName } from "@theguarantors/frontend-core/dist/features/buildings"
import { HelperText } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { INVALID_BUILDING } from "./AddressForm.validate";

export const generateQueryByBuildingName = (buildingsList: Building[], buildingName: string, unit: string): string => {
  const buildingId = (findBuildingByName(buildingsList, buildingName) || {}).id
  if (!buildingId) {
    throw new Error(INVALID_BUILDING)
  }
  return `?building=${buildingId}&unit=${encodeURIComponent(unit)}`
}

export const goToSignUpPage = (query: string): void =>  {
  window.location.href = `${process.env.REACT_APP_MONOLITH_URL || ""}/sign-up${query}`
}

export const generateFullBuildingName = ({name, street, city, state, zipCode}: Building) =>
  <div>
    {name}
    <div>
      <HelperText>
        {[street, city, state, zipCode].filter(v => v).map(v => v.trim()).join(", ")}
      </HelperText>
    </div>
  </div>
